var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTractor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tractor 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.9892 9.13769H9.64832C9.05499 9.13769 8.57999 8.6627 8.57999 8.06936C8.57999 7.47686 9.05499 7.00186 9.64832 7.00186H21.9892C22.5825 7.00186 23.0575 7.47686 23.0575 8.07019C22.9383 8.66353 22.5825 9.13769 21.9892 9.13769Z",
    fill: "#2CA07D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.8875 16.496C23.65 14.9535 23.2942 11.5119 23.0567 9.96937C22.9383 9.49437 22.5817 9.0202 21.9883 9.0202H10.7158C9.52917 9.0202 8.69833 9.96937 8.69833 11.0377V17.2085V28.4819H34.33V25.5152V22.5485C34.33 21.8369 33.9742 21.1244 33.3808 20.7685C30.8892 19.226 27.685 18.0394 24.8367 17.446C24.3625 17.3269 24.0067 16.971 23.8875 16.496Z",
    fill: "#54D4AE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.5825 15.6652L21.8708 10.5627C21.8708 10.3252 21.6333 10.0877 21.3958 10.0877H17.3617C17.1242 10.0877 16.8867 10.3252 16.8867 10.5627V15.6652C16.8867 15.9027 17.1242 16.1402 17.3617 16.1402H21.9892C22.345 16.2585 22.5825 16.021 22.5825 15.6652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.88583 11.156V15.7835C9.88583 16.021 10.1233 16.2585 10.3608 16.2585H15.345C15.5825 16.2585 15.82 16.021 15.82 15.7835V10.681C15.82 10.4435 15.5825 10.206 15.345 10.206H10.8358C10.36 10.0885 9.88583 10.5627 9.88583 11.156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88667 20.041C8.42834 18.7569 10.5008 17.8402 12.7333 17.8402C17.4342 17.8402 21.3558 21.6277 21.3558 26.4627C21.3558 26.8994 21.0017 27.2535 20.565 27.2535C20.1283 27.2535 19.7742 26.8994 19.7742 26.4627C19.7742 22.5169 16.5767 19.4219 12.7333 19.4219C10.9308 19.4219 9.20667 20.1669 7.9 21.256C7.56417 21.536 7.06584 21.4902 6.78584 21.1544C6.50584 20.8202 6.55167 20.321 6.88667 20.041Z",
    fill: "#2CA07D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.7333 33.581C16.6658 33.581 19.8533 30.3935 19.8533 26.461C19.8533 22.5285 16.6658 19.341 12.7333 19.341C8.80084 19.341 5.61334 22.5285 5.61334 26.461C5.61334 30.3935 8.80084 33.581 12.7333 33.581Z",
    fill: "#232429"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M12.7333 30.6185C15.0275 30.6185 16.8867 28.7594 16.8867 26.4652C16.8867 24.171 15.0275 22.3119 12.7333 22.3119C10.44 22.3119 8.57999 24.171 8.57999 26.4652C8.57999 28.7585 10.44 30.6185 12.7333 30.6185Z",
    fill: "#898B94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8417 26.7119C24.6508 24.0152 27.205 21.9952 30.1767 21.9952C32.4858 21.9952 34.5067 23.2202 35.7075 25.0877C35.9442 25.4552 35.8375 25.9444 35.47 26.181C35.1025 26.4169 34.6133 26.311 34.3767 25.9435C33.4417 24.4885 31.9025 23.5777 30.1767 23.5777C27.9267 23.5777 25.9717 25.1177 25.3575 27.1669C25.2317 27.5852 24.7908 27.8227 24.3725 27.6977C23.9542 27.571 23.7167 27.1302 23.8417 26.7119Z",
    fill: "#2CA07D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M30.1767 33.7002C32.995 33.7002 35.2792 31.416 35.2792 28.5977C35.2792 25.7794 32.995 23.4952 30.1767 23.4952C27.3583 23.4952 25.0742 25.7794 25.0742 28.5977C25.0742 31.416 27.3592 33.7002 30.1767 33.7002Z",
    fill: "#232429"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M30.1767 30.6161C31.2908 30.6161 32.1942 29.7127 32.1942 28.5986C32.1942 27.4844 31.2908 26.5811 30.1767 26.5811C29.0625 26.5811 28.1592 27.4844 28.1592 28.5986C28.16 29.7136 29.0625 30.6161 30.1767 30.6161Z",
    fill: "#898B94"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTractor);
export default __webpack_public_path__ + "static/media/tractor.612aeddd7d27c53f7e8528d42bdd816c.svg";
export { ForwardRef as ReactComponent };